<template>
  <div class="content-register-address">
    <div class="holder container">
      <div class="content-register-address-body">
        <div class="content-register-address-body-download">
          <div class="content-register-address-body-download-item">
            <button v-if="!isPc" class="btn-address btn-disable">
              {{ $t('front_end.a050.download_template') }}
            </button>
            <button
              v-else
              class="btn-address"
              @click="$refs.confirmDownload.show()"
            >
              {{ $t('front_end.a050.download_template') }}
            </button>
          </div>
          <div class="content-register-address-body-download-item">
            <input
              type="file"
              @change="handleChooseFile"
              :accept="fileAccept"
              ref="inputFile"
              id="choose_file"
              class="w-100"
              hidden
            />
            <button v-if="!isPc" class="btn-address btn-disable">
              {{ $t('front_end.a050.upload_file') }}
            </button>
            <button v-else class="btn-address" @click="onChosseFile">
              {{ $t('front_end.a050.upload_file') }}
            </button>
          </div>
          <div class="content-register-address-body-download-item">
            <div class="name-file-csv p-0" v-if="data.fileName">
              <p class="m-0">{{ $t('front_end.a050.name_file') }}</p>
              <p class="m-0">{{ data.fileName }}</p>
            </div>
            <div class="content-register-address-body-download-item">
              <button
                class="btn-address"
                v-if="data.fileName"
                @click="$refs.confirmImport.show()"
              >
                {{ $t('front_end.a050.read_file') }}
              </button>
            </div>
            <div class="line-read-csv" v-if="data.fileName"></div>
          </div>
          <div class="content-register-address-body-download-item">
            <button class="btn-address" @click="redirectUrl">
              {{ $t('front_end.a050.enter_address') }}
            </button>
          </div>
        </div>
        <div class="content-btn-confirm">
          <p class="content-register-address-body-destination-ttl">
            {{ $t('front_end.a050.list_receiver') }}
          </p>
          <div class="content-register-address-body-button">
            <button
              class="btn-address"
              :class="!isExitsCheck ? 'btn-disable' : ''"
              @click="onRegisterConfirm()"
            >
              {{ $t('front_end.a050.confirm') }}
            </button>
          </div>
        </div>
        <div class="content-register-address-body-destination">
          <table class="content-register-address-body-destination-table">
            <tr>
              <td>{{ $t('front_end.a050.no') }}</td>
              <td class="p-0">
                <p class="m-0 name-receiver">{{ $t('front_end.a050.name') }}</p>
                <p class="m-0 name-receiver border-name">
                  {{ $t('front_end.a050.joint_name') }}
                </p>
              </td>
              <td>{{ $t('front_end.a050.address') }}</td>
              <td>
                <label class="custom-control checkcontainer custom-checkbox">
                  <input v-model="selectAll" type="checkbox" hidden />
                  <span class="checkmark"></span>
                </label>
              </td>
            </tr>
            <tr v-for="(dataReceiver, i) in listReceiver" :key="i">
              <td>{{ i + 1 }}</td>
              <td class="text-left p-0">
                <p class="name-receiver">
                  {{ dataReceiver.firstName }}{{ dataReceiver.lastName
                  }}{{ dataReceiver.honorific }}
                  <!-- {{ dataReceiver.jointName }} -->
                </p>

                <template v-if="dataReceiver.jointNameArray">
                  <p
                    class="m-0 name-receiver border-name"
                    v-for="(jnName, keyName) in dataReceiver.jointNameArray"
                    :key="keyName"
                  >
                    {{ jnName.lastName }}{{ jnName.honorific }}
                  </p>
                </template>
                <template v-else-if="dataReceiver.jointName">
                  <p
                    class="m-0 name-receiver border-name"
                    v-for="(jnName, keyName) in dataReceiver.jointName.split(
                      ','
                    )"
                    :key="keyName"
                  >
                    {{ jnName }}
                  </p>
                </template>
              </td>
              <td class="text-left pl-4">
                {{
                  `〒${dataReceiver.postNo} ${dataReceiver.prefecture} ${dataReceiver.city} ${dataReceiver.street}
                ${dataReceiver.building}`
                }}
              </td>
              <td>
                <label class="custom-control checkcontainer custom-checkbox">
                  <input
                    v-model="dataReceiver.checkDefault"
                    type="checkbox"
                    hidden
                  />
                  <span class="checkmark"></span>
                </label>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <fe-alert ref="confirmDownload" :datas="confirmDownload">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <span v-html="$t('front_end.a050.csv.message_confirm_download')" />
        </div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          class="btn-dialog col-6 border-top border-right"
          @click="csvExport(csvData)"
        >
          {{ $t('front_end.a050.csv.yes') }}
        </button>
        <button
          type="button"
          class="btn-dialog col-6 border-top border-left"
          @click="$refs.confirmDownload.hide()"
        >
          {{ $t('front_end.a050.csv.cancel') }}
        </button>
      </template>
    </fe-alert>
    <fe-alert ref="confirmImport" :datas="confirmImport">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <span v-html="$t('front_end.a050.csv.message_confirm_read_file')" />
        </div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          class="btn-dialog col-6 border-top border-right"
          @click="onReadFileCSVUpload()"
        >
          {{ $t('front_end.a050.csv.yes') }}
        </button>
        <button
          type="button"
          class="btn-dialog col-6 border-top border-left"
          @click="$refs.confirmImport.hide()"
        >
          {{ $t('front_end.a050.csv.cancel') }}
        </button>
      </template>
    </fe-alert>
    <fe-alert ref="updateAddress" :datas="updateAddress">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <span v-html="$t('front_end.a050.csv.insert_complete')" />
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn-dialog col-6 border-top border-right"
            @click="$refs.updateAddress.hide()"
          >
            {{ $t('front_end.a050.csv.back_register') }}
          </button>
        </div>
      </template>
    </fe-alert>
    <fe-alert ref="importSuccess" :datas="importSuccess">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <div class="mt-4" v-html="$t('front_end.a050.csv.insert_complete')" />
          <button
            type="button"
            class="btn-dialog pb-0"
            @click="$refs.importSuccess.hide()"
          >
            {{ $t('front_end.a050.csv.back_register') }}
          </button>
        </div>
      </template>
    </fe-alert>
    <fe-alert ref="registerConfirm" :datas="registerConfirm">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <span v-html="$t('front_end.a050.csv.register_confirm')" />
        </div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          class="btn-dialog col-6 border-top border-right"
          @click="onUploadReceiver()"
        >
          {{ $t('front_end.a050.csv.yes') }}
        </button>
        <button
          type="button"
          class="btn-dialog col-6 border-top border-left"
          @click="$refs.registerConfirm.hide()"
        >
          {{ $t('front_end.a050.csv.cancel') }}
        </button>
      </template>
    </fe-alert>
    <fe-alert ref="registerSuccess" :datas="registerSuccess">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <div class="mt-5" v-html="$t('front_end.a050.csv.insert_complete')" />
          <button
            type="button"
            class="btn-dialog btn-success-ok mt-4 mb-3"
            @click="onSuccessRedirect()"
          >
            {{ $t('front_end.a050.csv.ok') }}
          </button>
        </div>
      </template>
    </fe-alert>
    <fe-alert ref="confirmBack" :datas="dataConfirmBack">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <span v-html="$t('front_end.a050.csv.confirm_delete')" />
        </div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          class="btn-dialog col-6 border-top border-right"
          @click="onConfirmBack()"
        >
          {{ $t('front_end.a050.csv.yes') }}
        </button>
        <button
          type="button"
          class="btn-dialog col-6 border-top border-left"
          @click="$refs.confirmBack.hide()"
        >
          {{ $t('front_end.a050.csv.cancel') }}
        </button>
      </template>
    </fe-alert>
    <fe-alert ref="readCsvError" :datas="readCsvError">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <div class="mt-3 py-4" v-html="readCsvError.errorText" />
        </div>
      </template>
    </fe-alert>
  </div>
</template>

<script>
import apiService from '../../services/api'
import apiEndpoints from '@/services/apiEndpoints'
import formMixin from '../../mixins/formMixin'
import FeAlert from '@/components/fe/common/FeAlert'
import { mapGetters } from 'vuex'
import deviceUtil from '../../utils/deviceUtil'
import Encoding from 'encoding-japanese'

export default {
  name: 'A050',
  mixins: [formMixin],
  components: {
    FeAlert,
  },
  mounted() {
    this.$root.$on('header-back', this.backBtnHandle)
  },
  beforeDestroy() {
    this.$root.$off('header-back', this.backBtnHandle)
  },
  data() {
    return {
      isPc: deviceUtil.isPc(),
      showReadFile: false,
      listReceiver: [],
      error: [],
      data: {
        fileName: '',
        file: '',
        content: '',
      },
      header: this.$t('front_end.a050.header_csv'),
      selected: [],
      allSelected: false,
      checkSeqNos: [],
      dataUploads: [],
      confirmDownload: {
        isShow: false,
        isShowClose: true,
        opts: {
          keyboard: false,
          backdrop: 'static',
        },
      },
      confirmImport: {
        isShow: false,
        isShowClose: true,
        opts: {
          keyboard: false,
          backdrop: 'static',
        },
      },
      updateAddress: {
        isShow: false,
        isShowClose: true,
        opts: {
          keyboard: false,
          backdrop: 'static',
        },
      },
      importSuccess: {
        isShow: false,
        isShowClose: false,
        opts: {
          keyboard: false,
          backdrop: 'static',
        },
      },
      registerConfirm: {
        isShow: false,
        isShowClose: true,
        opts: {
          keyboard: false,
          backdrop: 'static',
        },
      },
      registerSuccess: {
        isShow: false,
        isShowClose: false,
        opts: {
          keyboard: false,
          backdrop: 'static',
        },
      },
      readCsvError: {
        errorText: '',
        isShow: false,
        isShowClose: true,
      },
      dataConfirmBack: {
        isShow: false,
        isShowClose: true,
        opts: {
          keyboard: false,
          backdrop: 'static',
        },
      },
    }
  },
  created() {
    this.getPersonalAddress()
    document.addEventListener('keydown', function(e) {
      if (e.keyCode === 13 && e.target.nodeName.toLowerCase() === 'input') {
        e.preventDefault()
      }
    })
  },
  methods: {
    backBtnHandle() {
      if (this.listReceiver.length > 0) {
        this.$refs.confirmBack.show()
      } else {
        this.$router.push({ name: 'a035' })
      }
    },
    async onConfirmBack() {
      this.$refs.confirmBack.hide()
      await this.deleteReceiverList()
      localStorage.setItem('personal_address', '[]')
      this.$router.push({ name: 'a035' })
    },
    async deleteReceiverList() {
      let operation = 'delete'
      return await apiService.post(apiEndpoints.uploadReceiverList, {
        orderNo: this.userData.order.orderNo,
        operation,
      })
    },
    csvExport(csvData) {
      this.$refs.confirmDownload.hide()
      this.$helper.exportToCSV(csvData)
    },
    onRegisterConfirm() {
      if (!this.isExitsCheck) {
        return
      }
      this.$refs.registerConfirm.show()
    },
    async handleChooseFile(e) {
      if (e.target.files) {
        for (let i = 0; i < e.target.files.length; i++) {
          let file = e.target.files[i]
          this.data.fileName = file.name
          this.data.content = file
          this.data.file = file
        }
      }
    },
    async onUploadReceiver() {
      let operation = 'update'
      this.$refs.registerConfirm.hide()
      let receiverInfomation = []

      //

      receiverInfomation = this.listReceiver.filter((s) => {
        return s.checkDefault == true
      })
      receiverInfomation = JSON.parse(JSON.stringify(receiverInfomation))
      receiverInfomation.map((item) => {
        if (item && item.jointNameArray) {
          let tmpArr = item.jointNameArray.map((i) => {
            return i.lastName + ',' + i.honorific
          })
          item.jointName = tmpArr.join(',')
          delete item.jointNameArray
        }
        return item
      })
      try {
        let result = await apiService.post(apiEndpoints.uploadReceiverList, {
          // todo fake orderNo for tester
          orderNo: this.userData.order.orderNo,
          receiverInfomation: receiverInfomation,
          operation,
        })
        if (result && result.status == 200) {
          let listReceiver = []
          listReceiver = this.listReceiver.filter((s) => {
            return s.checkDefault == true
          })
          this.listReceiver = listReceiver
          let orderReceivers = []
          receiverInfomation.map((e) => {
            orderReceivers.push({
              name: e.firstName + e.lastName + e.honorific,
              address: `${e.postNo} ${e.prefecture} ${e.city} ${e.street} ${e.building}`,
            })
          })
          let order = this.userData.order
          order.receivers = orderReceivers
          this.$store.commit('userData/SET_ORDER', order)
          this.$refs.registerSuccess.show()
        }
      } catch (error) {
        // console.log(error);
      }
    },
    verifyEncoding(file) {
      return new Promise((r) => {
        let reader = new FileReader()
        reader.onload = function(e) {
          var codes = new Uint8Array(e.target.result)
          var encoding = Encoding.detect(codes)
          if (!(encoding === 'UTF8' || encoding === 'SJIS')) {
            return r({ status: false })
          }
          var unicodeArrayString = Encoding.convert(codes, {
            to: 'UNICODE',
            from: encoding,
          })
          var finalString = Encoding.codeToString(unicodeArrayString)
          return r({ status: true, text: finalString })
        }
        reader.readAsArrayBuffer(file)
      })
    },
    async onReadFileCSVUpload() {
      let error = []
      this.$refs.confirmImport.hide()
      this.validateFile(this.data.file, this.ruleValidate, error)
      this.error = error
      if (this.error.length) {
        this.readCsvError.errorText = this.error[0]
        this.$refs.readCsvError.show()
        this.data = { file: '', content: '', fileName: '' }
        return
      }
      if (!this.data.fileName) {
        this.readCsvError.errorText = this.$t('b040.pl_select_file')
        this.$refs.readCsvError.show()
        this.data = { file: '', content: '', fileName: '' }
        return
      }
      let self = this
      let arrData = []
      let dataCSV = ''
      let verifyEncode = await this.verifyEncoding(this.data.file)
      if (verifyEncode.status) {
        dataCSV = verifyEncode.text
      } else {
        this.error.unshift(self.$t('front_end.a050.csv.error_encoding'))
        self.showModalReadCSV()
        return ''
      }
      let isValidate = true
      if (!dataCSV.toString()) {
        self.error = []
        self.error.push(self.$t('front_end.a050.csv.error_not_format'))
        isValidate = false
      }
      let arrLines = dataCSV.split('\n')
      if (arrLines[arrLines.length - 1] === '') {
        arrLines.splice(-1, 1)
      }
      let arrHeader = arrLines[0].split(',')
      if (arrHeader.length !== 11) {
        self.error = []
        self.error.push(self.$t('front_end.a050.csv.error_not_format'))
        isValidate = false
      }
      if (!isValidate) {
        self.showModalReadCSV()
      } else {
        arrLines.forEach((line) => {
          let pros = line.split(',')
          let postNo = pros[0]
          let address = pros[1] ? pros[1].split(' ') : []
          let prefecture = address.length > 0 ? address[0] : ''
          let city = address.length > 1 ? address[1] : ''
          let street = address.length > 2 ? address[2] : ''
          let building = pros[2]
          let company = pros[3]
          let department = pros[4]
          let post = pros[5]
          let firstName = pros[6]
          let lastName = pros[7]
          let honorific = pros[8]
          let jointName = pros[9] + ',' + pros[10]
          let jointNameArray = [{ lastName: pros[9], honorific: pros[10] }]
          let checkDefault = true
          arrData.push({
            seqNo: '',
            postNo: postNo,
            prefecture: prefecture,
            city: city,
            street: street,
            building: building,
            company: company,
            department: department,
            post: post,
            firstName: firstName,
            lastName: lastName,
            honorific: honorific,
            jointName: jointName,
            jointNameArray,
            checkDefault: checkDefault,
          })
        })
        let arrDataCsv = arrData.splice(1)
        self.listReceiver = [...self.listReceiver, ...arrDataCsv]
        localStorage.setItem(
          'personal_address',
          JSON.stringify(self.listReceiver)
        )
        self.showModalReadCSV()
      }
    },
    redirectUrl() {
      this.$router.push({ name: 'a055' })
    },
    onChosseFile() {
      this.$refs.inputFile.values = ''
      this.$refs.inputFile.click()
    },
    getPersonalAddress() {
      let personalAddress = localStorage.getItem('personal_address')
        ? JSON.parse(localStorage.getItem('personal_address'))
        : []
      let listReceiver = this.listReceiver
      if (personalAddress.length) {
        this.listReceiver = [...listReceiver, ...personalAddress]
      }
    },
    onSuccessRedirect() {
      this.$refs.registerSuccess.hide()
      this.$router.push({ name: 'a060' })
    },
    showModalReadCSV() {
      this.data = { file: '', content: '', fileName: '' }
      if (this.error.length > 0) {
        this.readCsvError.errorText = this.error[0]
        this.$refs.readCsvError.show()
      } else {
        this.$refs.importSuccess.show()
      }
    },
  },
  computed: {
    ...mapGetters(['userData']),
    csvData() {
      return [...[this.header]]
    },
    ruleValidate() {
      return {
        size: {
          maxSize: this.$constant.MAX_FILE_SIZE,
          minSize: null,
          keyError: 0,
          message: this.$t('b040.fomat_file_incorrect'),
          ...this.ruleSize,
        },
        type: {
          format: ['csv'],
          message: this.$t('b040.select_file_incorrect'),
          keyError: 0,
          ...this.ruleType,
        },
      }
    },
    fileAccept() {
      return this.ruleValidate.type.format.map((f) => '.' + f).join(',')
    },
    isExitsCheck() {
      let listReceiver = []
      listReceiver = this.listReceiver.filter((s) => {
        return s.checkDefault == true
      })
      return listReceiver.length > 0 ? true : false
    },
    selectAll: {
      get: function() {
        let isCheckDefault = this.listReceiver.filter((s) => {
          return s.checkDefault == true
        })
        return isCheckDefault && isCheckDefault.length
          ? this.listReceiver.length == isCheckDefault.length
          : false
      },
      set: function(value) {
        if (value) {
          this.listReceiver.forEach(function(receiver) {
            receiver.checkDefault = true
          })
        } else {
          this.listReceiver.forEach(function(receiver) {
            receiver.checkDefault = false
          })
        }
        localStorage.setItem(
          'personal_address',
          JSON.stringify(this.listReceiver)
        )
      },
    },
  },
  watch: {
    listReceiver: {
      handler: function() {
        localStorage.setItem(
          'personal_address',
          JSON.stringify(this.listReceiver)
        )
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.dialog-complete {
  margin: 4rem auto 4rem !important;
  text-align: center;
}

.btn-back {
  background: #fff;
  border: 1px solid red;
  border-radius: 5px;
  min-width: 120px;
}
.modal-sm {
  max-width: 300px !important;
}

.dialog-body.dialog-complete {
  max-width: 300px !important;
  padding: 20px 30px !important;
  text-align: center;
  margin: 0;
}
/* Create a custom checkbox */
.custom-checkbox {
  margin-bottom: 0;
}

.checkmark {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 20px;
  width: 20px;
  background-color: #fff;
  transform: translate(-50%, -50%);
  border: 0.1px solid #000;
  border-radius: 2px;
}

/* On mouse-over, add a grey background color */
.custom-checkbox:hover input ~ .checkmark {
  background-color: #fff;
}

/* When the checkbox is checked, add a blue background */
.custom-checkbox input:checked ~ .checkmark {
  background-color: red;
  border: 0.1px solid red;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.custom-checkbox .checkmark:after {
  left: 50%;
  top: 50%;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: translate(-50%, -50%) rotate(45deg);
  -webkit-transform: translate(-50%, -50%) rotate(45deg);
  -ms-transform: translate(-50%, -50%) rotate(45deg);
}
</style>
<style
  lang="css"
  scoped
  src="../../assets/css/registerAddressReceiver/registerAddressReceiver.css"
></style>
<style scoped src="../../assets/css/common/dialogCommon.css"></style>
